module.exports = __webpack_public_path__ + "91e4b42f166b46ac38082389d4731b31.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_2.png
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_2.png
// module chunks = 40